import React from 'react';
import { Box, Typography } from '@mui/material';

import AddQuizEvaluation from '../Quiz_Evaluation/AddQuizEvaluation';
import { useAuth } from '../../Context/AuthContext';
import { useGetUserQuery } from '../../services/SkillsManagement';

const DashboardEmployee = () => {
  const { user } = useAuth();

  const employeeId = Number(user?.id);
  const { data: userResp } = useGetUserQuery(
    { userId: String(employeeId || '') },
    { skip: !Number.isFinite(employeeId) }
  );

  const posteObj = userResp?.user?.Poste || userResp?.user?.poste || null;
  const posteId = posteObj?.posteId || userResp?.user?.posteId || null;

  return (
    <Box p={3}>
      

      <AddQuizEvaluation
        inline
        open
        onClose={() => {}}
        posteId={posteId || undefined}
        initialViewMode="assigned"
      />

    </Box>
  );
};

export default DashboardEmployee;